var map = {
	"./Alien.webm": 764,
	"./Ape.webm": 765,
	"./CyberBot.webm": 766,
	"./Devil.webm": 767,
	"./Human.webm": 768,
	"./Orc.webm": 769,
	"./Rabbit.webm": 770,
	"./Zombie.webm": 771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 763;